
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30232',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30232",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54484",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.7993",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11446",
  "I18n": "static-7.1617",
  "quartz": "static-1-hqd-quartz-routing-v2.23",
  "quartz-config": "static-1-hqd-quartz-routing-v2.23",
  "quartz-core": "static-1-hqd-quartz-routing-v2.23",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.786",
  "enviro": "static-4.446",
  "feedback-shared-ui": "static-1.54471",
  "feedback-utils": "static-1.54475",
  "forms-embed-utils-lib": "static-1.4440",
  "forms-utils-lib": "static-1.12530",
  "foundations-assets": "static-1.4842",
  "foundations-components": "static-1.7885",
  "foundations-theming": "static-1.4397",
  "hub-http": "static-1.6200",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11753",
  "icons": "static-2.644",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3897",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16646",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5325",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57408",
  "transmute": "static-2.85",
  "ui-images": "static-2.1147",
  "UIComponents": "static-3.8392",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9619",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3385",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1-hqd-quartz-routing-v2.23",
  "quartz-webpack": "static-1-hqd-quartz-routing-v2.23",
  "foundations-theming-specialty": "static-1.2113",
  "property-description-translator": "static-1.3824",
  "HeadJS": "static-2.754",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3104",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4305",
  "jasmine-runner": "static-1.6445",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4634",
  "mobile-manifest-mixins": "static-1.529",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1-hqd-quartz-routing-v2.23",
  "quartz-head": "static-1-hqd-quartz-routing-v2.23",
  "quartz-i18n": "static-1-hqd-quartz-routing-v2.23",
  "quartz-routing": "static-1-hqd-quartz-routing-v2.23",
  "quartz-test": "static-1-hqd-quartz-routing-v2.23",
  "quartz-tracking": "static-1-hqd-quartz-routing-v2.23",
  "ui-fonts": "static-1.708",
  "usage-tracker-container": "static-1.7313",
  "usage-tracker-core": "static-1.7173",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7226",
  "reference-resolvers": "static-1.8147",
  "sanitize-text": "static-1.8121",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10348",
  "sanitize": "static-1.4456",
  "outpost": "static-1.4164",
  "rpc-client-utils": "static-1.4630",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4154",
  "floating-ui": "static-1.55",
  "hs-story-utils": "static-1.9406",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1802",
  "bend-plugin-foundations-theming": "static-1.2880",
  "foundations-theming-base": "static-1.3382",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.66",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "ai-components-ui-library": "static-1.8874",
  "atom": "static-1.5050",
  "codemirror": "static-5.94",
  "content-assistance-lib": "static-1.7714",
  "ContentUtils": "static-1.68284",
  "data-token-picker": "static-1.16363",
  "file-manager-components": "static-1.23549",
  "FileManagerCore": "static-1.39048",
  "FileManagerLib": "static-1.39189",
  "frontend-preferences-client": "static-1.7907",
  "hub-http-contrib": "static-1.3020",
  "interframe": "static-3.4739",
  "layout-dnd-components": "static-1.12399",
  "layout-dnd-utils": "static-1.11374",
  "property-translator": "static-1.5379",
  "react-codemirror": "static-1.10603",
  "react-colorpicker": "static-2.10188",
  "reference-resolvers-lite": "static-1.8073",
  "rich-text-lib": "static-1.19785",
  "tinymce-data": "static-1.40379",
  "tinymce-themes": "static-1.56264",
  "ui-addon-emoji-picker": "static-1.9867",
  "ui-addon-sales-email": "static-1.5189",
  "ui-brand-identity-lib": "static-1.15166",
  "bender-build-tools": "static-1.3171",
  "hub-http-shared-msw-handlers": "static-1.9903",
  "hubspotter-http-shared-msw-handlers": "static-1.9901",
  "usage-tracker-session-replay": "static-1.5009",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.40",
  "chirp-fetch": "static-1.1865",
  "chatspot-core": "static-1.21168",
  "copilot-toolkit": "static-1.11071",
  "customer-data-objects-ui-components": "static-1.13003",
  "data-fetching-client": "static-1.9649",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4742",
  "ui-addon-video-player": "static-1.8681",
  "ui-coaching-tips": "static-1.28477",
  "usage-tracker": "static-1.7323",
  "cms-field-types": "static-1.4790",
  "content-icons-ui": "static-1.2220",
  "integrations-lib": "static-1.16028",
  "customer-data-objects": "static-1.7641",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4628",
  "apollo-stack-hubspot": "static-3.85",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "immerable": "static-1.4132",
  "ui-addon-iframeable": "static-1.9035",
  "video-components-external": "static-1.11184",
  "video-data-lib": "static-1.34842",
  "audio-components": "static-1.5879",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29249",
  "FileManagerImages": "static-1.36700",
  "foundations-components-legacy": "static-1.910",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8950",
  "urlinator": "static-1.4515",
  "video-components": "static-1.13187",
  "video-embed": "static-1.35676",
  "ts-schema": "static-1.4062",
  "ContentData": "static-1.68359",
  "layout-data-lib": "static-1.9699",
  "react-dnd-compat": "static-1.4598",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1518",
  "external-options-client-types": "static-1.4139",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6861",
  "hs-promise-utils": "static-1.5574",
  "inbound-db-properties-service-client": "static-1.3828",
  "NamespacedHubStyle": "static-2.9041",
  "growth-onboarding-confetti": "static-1.3045",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11130",
  "amplitude-session-replay-browser": "static-1.59",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5539",
  "magpie-types": "static-1.4999",
  "simple-logging-lib": "static-1.3027",
  "avatar-components": "static-1.2476",
  "customer-data-ui-utilities": "static-1.9804",
  "growth-onboarding-feedback-components": "static-1.6560",
  "flux-actions": "static-1.333",
  "hubspot-apollo-client": "static-1.4855",
  "integrations-error-boundary-lib": "static-1.13443",
  "integrations-tracking-lib": "static-1.5577",
  "laboratory-lib": "static-3.7137",
  "native-integrations-shared-strings": "static-1.7761",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10135",
  "unified-auth": "static-1.464",
  "navigation-messaging": "static-1.7287",
  "content-media-composition-data-lib": "static-1.12172",
  "content-media-compositions": "static-2.16179",
  "idb-keyval": "static-1.43",
  "media-bridge-lib": "static-1.18881",
  "unified-auth-core-lib": "static-1.746",
  "social-insights-client-types": "static-1.22010",
  "advanced-menus-core": "static-1.15092",
  "advanced-menus-lib": "static-1.12037",
  "ExportDialog": "static-6.10370",
  "ui-memberships-settings-lib": "static-1.33974",
  "conditional-properties-service-client": "static-1.3778",
  "crm-pipelines-api-client-types": "static-1.4123",
  "framework-builder-read-service-client": "static-1.3990",
  "framework-data-schema-quick-fetch": "static-1.6766",
  "inbound-db-meta-service-client": "static-1.3571",
  "multi-currency-client-types": "static-1.3673",
  "persist-promise": "static-1.3675",
  "foundations-components-test-utils": "static-1.5368",
  "reactive-lib": "static-1.700",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.314",
  "universal-page-editor-lib": "static-1.2991",
  "google-sheets-integration-lib": "static-1.158",
  "microsoft-drive-integration-lib": "static-1.274",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3710",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15091",
  "simple-menus-lib": "static-1.16608",
  "crm-record-cards-service-types": "static-1.3587",
  "location-customization-utils-lib": "static-1.9172",
  "react-flip-move": "static-1.69"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30232",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54484",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.7993",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11446",
  "I18n": "/I18n/static-7.1617",
  "quartz": "/quartz/static-1-hqd-quartz-routing-v2.23",
  "quartz-config": "/quartz-config/static-1-hqd-quartz-routing-v2.23",
  "quartz-core": "/quartz-core/static-1-hqd-quartz-routing-v2.23",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.786",
  "enviro": "/enviro/static-4.446",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54471",
  "feedback-utils": "/feedback-utils/static-1.54475",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4440",
  "forms-utils-lib": "/forms-utils-lib/static-1.12530",
  "foundations-assets": "/foundations-assets/static-1.4842",
  "foundations-components": "/foundations-components/static-1.7885",
  "foundations-theming": "/foundations-theming/static-1.4397",
  "hub-http": "/hub-http/static-1.6200",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11753",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3897",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16646",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5325",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57408",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1147",
  "UIComponents": "/UIComponents/static-3.8392",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9619",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3385",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1-hqd-quartz-routing-v2.23",
  "quartz-webpack": "/quartz-webpack/static-1-hqd-quartz-routing-v2.23",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2113",
  "property-description-translator": "/property-description-translator/static-1.3824",
  "HeadJS": "/HeadJS/static-2.754",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3104",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4305",
  "jasmine-runner": "/jasmine-runner/static-1.6445",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4634",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.529",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1-hqd-quartz-routing-v2.23",
  "quartz-head": "/quartz-head/static-1-hqd-quartz-routing-v2.23",
  "quartz-i18n": "/quartz-i18n/static-1-hqd-quartz-routing-v2.23",
  "quartz-routing": "/quartz-routing/static-1-hqd-quartz-routing-v2.23",
  "quartz-test": "/quartz-test/static-1-hqd-quartz-routing-v2.23",
  "quartz-tracking": "/quartz-tracking/static-1-hqd-quartz-routing-v2.23",
  "ui-fonts": "/ui-fonts/static-1.708",
  "usage-tracker-container": "/usage-tracker-container/static-1.7313",
  "usage-tracker-core": "/usage-tracker-core/static-1.7173",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7226",
  "reference-resolvers": "/reference-resolvers/static-1.8147",
  "sanitize-text": "/sanitize-text/static-1.8121",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10348",
  "sanitize": "/sanitize/static-1.4456",
  "outpost": "/outpost/static-1.4164",
  "rpc-client-utils": "/rpc-client-utils/static-1.4630",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4154",
  "floating-ui": "/floating-ui/static-1.55",
  "hs-story-utils": "/hs-story-utils/static-1.9406",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1802",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2880",
  "foundations-theming-base": "/foundations-theming-base/static-1.3382",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.66",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8874",
  "atom": "/atom/static-1.5050",
  "codemirror": "/codemirror/static-5.94",
  "content-assistance-lib": "/content-assistance-lib/static-1.7714",
  "ContentUtils": "/ContentUtils/static-1.68284",
  "data-token-picker": "/data-token-picker/static-1.16363",
  "file-manager-components": "/file-manager-components/static-1.23549",
  "FileManagerCore": "/FileManagerCore/static-1.39048",
  "FileManagerLib": "/FileManagerLib/static-1.39189",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7907",
  "hub-http-contrib": "/hub-http-contrib/static-1.3020",
  "interframe": "/interframe/static-3.4739",
  "layout-dnd-components": "/layout-dnd-components/static-1.12399",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11374",
  "property-translator": "/property-translator/static-1.5379",
  "react-codemirror": "/react-codemirror/static-1.10603",
  "react-colorpicker": "/react-colorpicker/static-2.10188",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8073",
  "rich-text-lib": "/rich-text-lib/static-1.19785",
  "tinymce-data": "/tinymce-data/static-1.40379",
  "tinymce-themes": "/tinymce-themes/static-1.56264",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9867",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5189",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15166",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9903",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9901",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5009",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.40",
  "chirp-fetch": "/chirp-fetch/static-1.1865",
  "chatspot-core": "/chatspot-core/static-1.21168",
  "copilot-toolkit": "/copilot-toolkit/static-1.11071",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13003",
  "data-fetching-client": "/data-fetching-client/static-1.9649",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4742",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8681",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28477",
  "usage-tracker": "/usage-tracker/static-1.7323",
  "cms-field-types": "/cms-field-types/static-1.4790",
  "content-icons-ui": "/content-icons-ui/static-1.2220",
  "integrations-lib": "/integrations-lib/static-1.16028",
  "customer-data-objects": "/customer-data-objects/static-1.7641",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4628",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4132",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9035",
  "video-components-external": "/video-components-external/static-1.11184",
  "video-data-lib": "/video-data-lib/static-1.34842",
  "audio-components": "/audio-components/static-1.5879",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29249",
  "FileManagerImages": "/FileManagerImages/static-1.36700",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.910",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8950",
  "urlinator": "/urlinator/static-1.4515",
  "video-components": "/video-components/static-1.13187",
  "video-embed": "/video-embed/static-1.35676",
  "ts-schema": "/ts-schema/static-1.4062",
  "ContentData": "/ContentData/static-1.68359",
  "layout-data-lib": "/layout-data-lib/static-1.9699",
  "react-dnd-compat": "/react-dnd-compat/static-1.4598",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1518",
  "external-options-client-types": "/external-options-client-types/static-1.4139",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6861",
  "hs-promise-utils": "/hs-promise-utils/static-1.5574",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3828",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9041",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3045",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11130",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5539",
  "magpie-types": "/magpie-types/static-1.4999",
  "simple-logging-lib": "/simple-logging-lib/static-1.3027",
  "avatar-components": "/avatar-components/static-1.2476",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9804",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6560",
  "flux-actions": "/flux-actions/static-1.333",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4855",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13443",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5577",
  "laboratory-lib": "/laboratory-lib/static-3.7137",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7761",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10135",
  "unified-auth": "/unified-auth/static-1.464",
  "navigation-messaging": "/navigation-messaging/static-1.7287",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12172",
  "content-media-compositions": "/content-media-compositions/static-2.16179",
  "idb-keyval": "/idb-keyval/static-1.43",
  "media-bridge-lib": "/media-bridge-lib/static-1.18881",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.746",
  "social-insights-client-types": "/social-insights-client-types/static-1.22010",
  "advanced-menus-core": "/advanced-menus-core/static-1.15092",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12037",
  "ExportDialog": "/ExportDialog/static-6.10370",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33974",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3778",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4123",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3990",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6766",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3571",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3673",
  "persist-promise": "/persist-promise/static-1.3675",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5368",
  "reactive-lib": "/reactive-lib/static-1.700",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.314",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2991",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.158",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.274",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3710",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15091",
  "simple-menus-lib": "/simple-menus-lib/static-1.16608",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9172",
  "react-flip-move": "/react-flip-move/static-1.69"
}
};
